import React, { Component } from "react";

import { CCard, CCardBody, CLink } from "@coreui/react";
import { ReactFlowProvider } from "react-flow-renderer";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import ActivityNode from "../FlowNodes/ActivityNode";
import InputNode from "../FlowNodes/InputNode";
import Loading from "../Loading";

// const getLastTrailActivity = allocation => {
//   if (allocation.trail.trail_activities.length === 0) {
//     return {};
//   }

//   if (allocation.trail.trail_activities.length === 1) {
//     return allocation.trail.trail_activities[0];
//   }

//   return allocation.trail.trail_activities.reduce((acc, val) => {
//     if (acc.activity.executions.length === 0) {
//       return acc;
//     }

//     if (
//       new Date(acc.activity.executions[0].created_at) >
//       new Date(val.activity.executions[0].created_at)
//     ) {
//       return acc;
//     }

//     return val;
//   }, allocation.trail.trail_activities[0]);
// };

class CommunityContentTrails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      trails: []
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.handleTrails();
  }

  // handleTrails() {
  //   const { id } = this.props.match.params;

  //   axios
  //     .get(`${URL.api}activity/trail_allocation/listByRoom`, {
  //       params: { room_id: id },
  //       headers: { Authorization: `Bearer ${this.props.user.token}` }
  //     })
  //     .then(
  //       resp => {
  //         if (resp.data.success) {
  //           this.setState({ trails: resp.data.data, loading: false });
  //         } else {
  //           toastr.error("Falha", "Não foi possível obter as trilhas");
  //           this.setState({ loading: false });
  //         }
  //       },
  //       () => {
  //         toastr.error("Falha", "Não foi possível obter as trilhas");
  //         this.setState({ loading: false });
  //       }
  //     );
  // }

  async handleTrails() {
    try {
      const { id } = this.props.match.params;
      const trailsResponse = await axios.get(
        `${URL.api}activity/trail_allocation/listByRoomId/${id}`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      );

      this.setState({ trails: trailsResponse.data.data, loading: false });
    } catch (error) {
      toastr.error("Falha", "Não foi possível obter as trilhas");
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.loading ? (
          <Loading />
        ) : (
          <div>
            {this.state.trails.length > 0 ? (
              <>
                {this.state.trails.map(allocation => (
                  <CCard key={allocation.id}>
                    <CCardBody className="p-0 d-flex flex-column flex-sm-row">
                      <div className="d-flex flex-column p-4 flex-1 text-ellipsis">
                        <CLink
                          style={{ color: "inherit" }}
                          to={`/trail/do/${allocation.id}`}
                        >
                          <h2 className="mb-1 text-ellipsis">
                            {allocation.name}
                          </h2>
                        </CLink>
                        <div className="text-muted mb-4 text-ellipsis">
                          {allocation.description}
                        </div>
                        <div className="d-flex align-items-center text-ellipsis">
                          <CLink to={`/profile/${allocation.user_id}`}>
                            <img
                              src={
                                URL.img +
                                (allocation.user_photo ||
                                  "uploads/users/profileEmpty.jpg")
                              }
                              className="rounded-circle mr-2"
                              style={{ width: "28px", height: "28px" }}
                            />
                            {allocation.user_name}
                          </CLink>
                        </div>
                      </div>
                      <div
                        className="px-4 d-flex justify-content-center align-items-center flex-column"
                        style={{ pointerEvents: "none", minHeight: "100px" }}
                      >
                        <div
                          className="flex-1"
                          style={{
                            borderLeft:
                              allocation.activity_current_step_type === "start"
                                ? "0px"
                                : "2px dashed var(--primary)"
                          }}
                        ></div>
                        <ReactFlowProvider>
                          {allocation.activity_current_step_type === "start" ? (
                            <InputNode
                              id="0"
                              data={{
                                temporary: false,
                                editable: false,
                                activity: {
                                  name: allocation.activity_current_step_name
                                }
                              }}
                              selected={false}
                              isConnectable={false}
                              xPos={0}
                              yPos={0}
                            />
                          ) : (
                            <ActivityNode
                              id="0"
                              data={{
                                temporary: false,
                                editable: false,
                                activity: {
                                  name: allocation.activity_current_step_name
                                }
                              }}
                              selected={false}
                              isConnectable={false}
                              xPos={0}
                              yPos={0}
                            />
                          )}
                        </ReactFlowProvider>
                        <div
                          className="flex-1"
                          style={{ borderLeft: "2px dashed var(--secondary)" }}
                        ></div>
                      </div>
                    </CCardBody>
                  </CCard>
                ))}
              </>
            ) : (
              <div className="p-4 d-flex align-items-center justify-content-center text-muted">
                Nenhuma trilha encontrada
              </div>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentTrails);
